import { type RouteRecordRaw } from 'vue-router';

import { LAYOUTS, ROUTE_NAMES } from '@/constants';
import { loadSegmentAnalytics } from '@/segment';

const RetailerRegistration = () => import('@/pages/Registration/RetailerRegistration.vue');

const routes: RouteRecordRaw[] = [
  {
    path: '/register/retailer/',
    name: ROUTE_NAMES.RETAILER_REGISTRATION,
    component: RetailerRegistration,
    beforeEnter: [loadSegmentAnalytics],
    meta: {
      layout: LAYOUTS.FULL,
    },
  },
];

export default routes;
